import React from 'react';
import * as styles from './CategoryHeadingButton.module.scss';
import Caret from '../../components/Caret';
import IconButton from '../../components/IconButton';
import Tooltip from '../../components/Tooltip';

interface CategoryHeadingProps {
  selectedEntityCategory?: string | null;
  onHeaderClick: () => void;
}

const CategoryHeadingButton = ({
  selectedEntityCategory,
  onHeaderClick,
}: CategoryHeadingProps) => {
  const tooltip = selectedEntityCategory ? 'Go back' : 'Show all';

  return (
    <Tooltip content={tooltip} placement="bottom" display="block">
      <IconButton
        className={styles.icon}
        onClick={() => onHeaderClick()}
        size="small"
        aria-label={tooltip}
      >
        <Caret
          direction={selectedEntityCategory ? 'left' : 'right'}
          size={10}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CategoryHeadingButton;
